import gql from 'graphql-tag';

export const CHECK_CAN_ROLLBACK = gql`
  query CheckCanRollback($id: ID!, $type: TypeRollBack!) {
    checkCanRollBackVerified(id: $id, type: $type) {
      valid
    }
  }
`;
